import { ModalV2Props, ModalV2 } from "@introist/react-foundation/v2";
import { DataMapping, DataMappingEditor, DataMappingField } from "./DataMappingEditor";
import { ReactNode, useState } from "react";
import { FormFooter } from "../../datasources/components/FormFooter";

export const DataMappingEditorModal = ({
  initialValue,
  onSave,
  sourceFields,
  targetFields,
  sourceHeader,
  targetHeader,
  ...rest
}: ModalV2Props & {
  initialValue: DataMapping[];
  onSave: (mappings: DataMapping[]) => Promise<unknown>;
  sourceFields?: DataMappingField[];
  targetFields?: DataMappingField[];
  sourceHeader?: ReactNode;
  targetHeader?: ReactNode;
}) => {
  const [value, setValue] = useState(initialValue);

  return (
    <ModalV2
      title="Edit data mapping"
      {...rest}
      footer={
        <FormFooter
          onCancel={() => rest.onClose && rest.onClose()}
          onSubmit={() => onSave(value)}
        />
      }
    >
      <DataMappingEditor
        value={value}
        onChange={setValue}
        blended
        sourceFields={sourceFields}
        targetFields={targetFields}
        sourceHeader={sourceHeader}
        targetHeader={targetHeader}
      />
    </ModalV2>
  );
};
